import { Platform, ResourceType } from "../../../../../models/api";

export const unsupportedResourceTypesByPlatform: {
    [platform in Platform]?: ResourceType[];
} = {
    [Platform.powerplatform]: [
        ResourceType.user,
        ResourceType.azure_active_directory_group,
        ResourceType.connection,
        ResourceType.gateway,
        ResourceType.gateway_cluster,
        ResourceType.virtual_connector,
    ],
    [Platform.powerBI]: [
        ResourceType.user,
        ResourceType.azure_active_directory_group,
        ResourceType.app,
        ResourceType.workspace,
        ResourceType.dashboard,
        ResourceType.datasource,
        ResourceType.lakehouse,
        ResourceType.ai_skill,
        ResourceType.warehouse,
    ],
};

export const unsupportedAllResourceTypes = [
    ResourceType.user,
    ResourceType.azure_active_directory_group,
    ResourceType.connection,
    ResourceType.gateway,
    ResourceType.gateway_cluster,
    ResourceType.virtual_connector,
    ResourceType.app,
    ResourceType.workspace,
    ResourceType.dashboard,
    ResourceType.datasource,
    ResourceType.warehouse,
];
